import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import { Settings } from '../interfaces/Settings';
import { SetStateAction } from 'react';

interface TempValueProgress {
    progress: {
        [key: string]: {
            required: boolean
        }
    }
}

type SettingsState = {
    settings: Settings; // Change the type to Record<string, Setting>
    setSettings: (settings: Settings) => void;
    tempValueProgress: TempValueProgress;
    setTempValueProgress: (key: string, required: boolean) => void;
}

const initialTempValueProgress: TempValueProgress = {
    progress: {},
};


export const useSettingsStore = create<SettingsState>()(
    persist(
        (set) => ({
            tempValueProgress: initialTempValueProgress,
            setTempValueProgress: (key: string, required: boolean) => {
                if (!key) {
                    console.error('Key cannot be empty');
                    return;
                }
                set((state) => ({
                    tempValueProgress: {
                        ...state.tempValueProgress,
                        progress: {
                            ...state.tempValueProgress.progress,
                            [key]: { required },
                        },
                    },
                }));
            },
            settings: {
                merchant_title: 'Klien',
                pipeline_title: 'Pipeline',
                meeting_title: 'Meeting',
                reimbursement_title: 'Reimbursement',
                users_title: 'Users',
                invoice_title: 'Invoice',
                merchant_custom_fields: '',
                pipeline_custom_fields: '',
                meeting_custom_fields: '',
                pipeline_date_min: "",
                template_pipeline: "",
                caps_lock_inputs: false,
                merchant_duplicate: false,
                merchant_phone_can_be_changed: false,
                hide_top_three_sales: false,
                feature_check_number: false,
                feature_pipeline: false,
                feature_meeting: false,
                feature_chat: false,
                feature_chat_super_admin: false,
                feature_invoice: false,
                pipeline_abandoned_lock: false,
                feature_meeting_mode: "0",
                chat_show_pic_only: false,
                chat_superadmin_merchant_only: false,
                meeting_auto_cancel: -1,
                radius_visit: 1,
                update_meeting: false,
                meeting_visit_disable_capture_camera: false,
                meeting_done_disable_capture_camera: false,
                default_pipeline_view_mode: 'table',
                is_superadmin_allowed_as_pic: false,
                chat_version: 'v1',
                sessionsTimeoutInSeconds: '0',
                allowAgentPreemptiveStartSessions: false,
                captionWhenSessionEnded: '',
                can_init_chat: false,
                feature_master: true,
                is_pipeline_discount_hidden: false,
                is_pipeline_label_required: false,
                lead_optional_product: false,
                chat_show_lead_pic: false,
                chat_show_merchant_pic: false,
            } as Settings, // Initialize settings as an object
            setSettings: (settings) => {
                set({ settings })
            },
        }),
        {
            name: 'settings-store',
            storage: createJSONStorage(() => localStorage),
        }
    )
)